const actionTypes = {
    GET_EVENTS_BY_GROUP_SUCCESS: 'GET_EVENTS_BY_GROUP_SUCCESS',
    GET_EVENT_PROCESSES: 'GET_EVENT_PROCESSES',
    GET_EVENT_PROCESSES_ORDER: 'GET_EVENT_PROCESSES_ORDER',
    GET_REF_DATA_EVENT_MONITORING_DATA: 'GET_REF_DATA_EVENT_MONITORING_DATA',
    GET_REF_DATA_EVENT_WIDGET_DATA: 'GET_REF_DATA_EVENT_WIDGET_DATA'
};

export default actionTypes;